import _ from "lodash";
import filter from "@/filter/filter.sub.js"
export default {
  name: "selectEle",
  data() {
    return {
      search: {
        class1: "",
        class2: "",
        keywork: ""
      },
      elelist: [],
      selectTag: "search",
      select: []
    }
  },
  methods: {
    async searchEle() {
      const list = await this.$store.dispatch("productInsert/searchEle");
      this.elelist = list;
    },
    importEle() {
      const result = {};
      _.each(this.select, (item, keys) => {
        if (result[item.uid]) {
          if (result[item.uid].delete == 1 && item.delete == 0) {
            result[item.uid] = item;
          }
        } else {
          result[item.uid] = item;
        }
      })
      this.$emit("save", {
        data: _.clone(result)
      });
    },
    showfunc() {
      console.log(this.selectdata);
      this.elelist = [];
      this.select = _.map(this.selectdata, (item) => {
        return _.clone(item);
      });
      this.selectTag = "search";
      this.search = {
        class1: "",
        class2: "",
        keywork: ""
      }
    },
    inviteitem(item) {
      const tmp = _.clone(item);
      tmp.delete = 0;
      this.select.push(tmp);
    },
    removeitem(item) {
      const tmp = _.findIndex(this.select, {
        uid: item.uid,
        delete: 0
      });
      if (tmp > -1) {
        this.select[tmp].delete = 1;
        this.select = this.select;
      }
      //   console.log(this.select);
    }
  },
  computed: {
    checkselect: {
      get() {
        return (check) => {
          const a = _.filter(this.selectlist, {
            uid: check
          }).length > 0;
          return a
        }
      }
    },
    selectlist: {
      get() {
        return filter.filter(this.select, {
          delete: 0
        })
      }
    },
    showbox: {
      get() {
        return this.show
      },
      set(data) {
        this.$emit("update:show", data)
      }
    },
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectdata: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

}
